import React, { useState } from 'react';
import Tag from '../Common/Tag';
import Tooltip from '../Common/Tooltip';
import { getTagExplanation } from '../../utils/tagUtils';
import { Tag as TagType } from '../../types/types';
import { logEvent } from '../../utils/Logger';

interface TagListProps {
  tags: TagType[];
  setTags: (tags: TagType[]) => void;
}

const scores = {
  'Extremely Likely': 5,
  'Likely': 4,
  'Moderate': 3,
  'Unlikely': 2,
  'Extremely Unlikely': 1,
};

const TagEditor: React.FC<TagListProps> = ({ tags, setTags }) => {
  
  // Toggle each tag's selected state???
  // but the dependency should come from the parent component

  // make a toggle function
  const toggleTag = (tag: TagType) => {
    const newTags = tags.map((t) => {
      if (t === tag) {
        return { ...t, deselected: !t.deselected };
      }
      return t;
    });
    const payload = {
      tag: tag.frame,
      selected: !tag.deselected,
      newTags: newTags
    }
    logEvent('tag_toggle', JSON.stringify(payload), window.location.href);
    setTags(newTags);
  };

  const onTagClick = (tag: TagType) => {
    toggleTag(tag);
    // log
  }

  const tags_sorted = tags.sort((a, b) => {
    return scores[b.likelihood] - scores[a.likelihood];
  });
    
  return (
    <div className="tag-list">
      {tags_sorted.map((tag, index) => {
        const { description, color } = getTagExplanation(tag?.frame);
        return (
          <Tooltip key={index} content={description} color={color}>
            <Tag tag={tag} onClick={() => onTagClick(tag)}/>
          </Tooltip>
        );
      })}
    </div>
  )
}

export default TagEditor;